<script setup>
const props = defineProps({
  h2: { type: String, required: false },
  body: { type: String, required: false },
  cta: {
    type: Object,
    required: false,
    validate: (value) => {
      return value && typeof value.path === "string" && typeof value.text === "string";
    },
  },
  cta2: {
    type: Object,
    required: false,
    validate: (value) => {
      return value && typeof value.path === "string" && typeof value.text === "string";
    },
  },
  badge: {
    type: String,
    required: false,
  },
});
</script>

<template>
  <div>
    <span
      v-if="badge"
      class="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-1 text-xs font-medium shadow-sm"
    >
      <span class="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
      {{ badge }}
    </span>
    <h2
      class="font-extrabold text-3xl sm:text-5xl font-iq-header leading-iq-header tracking-iq-header text-iq-header-color"
    >
      <slot name="h2">
        {{ h2 }}
      </slot>
    </h2>

    <p class="text-lg text-justify">
      <slot name="body">
        {{ body }}
      </slot>
    </p>

    <!-- CTAs -->

    <div class="flex flex-wrap items-center gap-3">
      <slot name="ctas">
        <FlexuilibCta
          v-if="cta"
          :label="cta.label"
          :path="cta.path"
          :icon="cta?.icon"
          :type="cta?.type"
        />
        <FlexuilibCta
          v-if="cta2"
          :label="cta2.label"
          :path="cta2.path"
          :icon="cta2?.icon"
          :type="cta2?.type"
        />
      </slot>
    </div>
  </div>
</template>
